export default __webpack_public_path__ + "static/media/Lora-VariableFont_wght.e85c1a8e.woff2";